import { useContext } from 'react';
import { AssistantContext } from 'src/contexts/assistant/AssistantContext';
import { TAssistantContextValue } from 'src/contexts/assistant/types';

const MISSING_PROVIDER_ERROR =
    'useAssistantContext must be used within AssistantProvider';

/**
 * Typed access to AssistantContext.
 */
export const useAssistantContext = (): TAssistantContextValue => {
    const value = useContext(AssistantContext);
    if (!value) throw new Error(MISSING_PROVIDER_ERROR);
    return value;
};
